import { MiddlewareAPI } from 'redux';

import { IWidgetStateWithPersistance, ImmutableWidgetStateWithPersistance } from '../WidgetBlocks/types/IWidgetBlock';
import { WidgetBlockAction } from './widgetblock/actions/types';
import { loadedPersistedState } from './widgetblock/actions';
import { WidgetsState } from './WidgetBlockWrapper';

const DELIMITER = '___/___';
const PREFIX = 'widgetBlockState';

type Dispatch = (next: WidgetBlockAction) => WidgetBlockAction;

//@ts-ignore todo WidgetsState is erroring
const persistWidgetBlockStateMiddleware = (store: MiddlewareAPI<WidgetsState>) => (next: Dispatch) => (action: WidgetBlockAction) => {
    const { widgetId, instanceId } = action.payload;
    const widget = store.getState().widgetBlocks.widgetModels.get(widgetId)?.get(instanceId);

    if (widget) {
        const stateToPersist = (widget as IWidgetStateWithPersistance).persistance || (widget as ImmutableWidgetStateWithPersistance).get?.('persistance');

        if (stateToPersist) {
            const combinedId = `${PREFIX}${DELIMITER}${widgetId}${DELIMITER}${instanceId}`;
            const stateToPersistJSON = JSON.stringify(stateToPersist);

            localStorage.setItem(combinedId, stateToPersistJSON);
        }
    }

    return next(action);
};

const createLoadedPersistedStateActions = () =>
    Object.keys(localStorage)
        .filter((key) => key.indexOf(`${PREFIX}${DELIMITER}`) === 0)
        .map((key) => {
            const [, widgetId, instanceId] = key.split(DELIMITER);
            const item = localStorage.getItem(key);
            const widgetBlockState = item ? JSON.parse(item) : null;

            return loadedPersistedState(widgetId, instanceId, widgetBlockState);
        });

export { persistWidgetBlockStateMiddleware, createLoadedPersistedStateActions };
